import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from '../../helpers/i18n';

/**
 * @export
 * @typedef  LocalizedButtonProps
 * @property {string} [ariaLabel]
 * @property {Record<string, any>} [options]
 * @property {string} [shouldRetranslate]
 */

/**
 * @type {React.ForwardRefExoticComponent<import('@mui/material').ButtonProps & LocalizedButtonProps>}
 */
const LocalizedButton = React.forwardRef(
    ({ ariaLabel, options, shouldRetranslate, ...remain }, ref) => {
        return <Button ref={ref} aria-label={translate(ariaLabel, options)} {...remain} />;
    }
);

LocalizedButton.propTypes = {
    ariaLabel: PropTypes.string,
    options: PropTypes.object,
    shouldRetranslate: PropTypes.string,
};

export default LocalizedButton;
